import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/components/layouts/Default.vue'
import NotFound from '@/views/error/NotFound.vue'
import Error from '@/views/error/Error.vue'
import Timeout from '@/views/error/Timeout.vue'
import MembersCard from '@/views/members-card/MembersCard.vue'
import MyPageLink from '@/views/mypage-link/MyPageLink.vue'

/** @type {import('vue-router').RouteRecordRaw[]} */
const routes = [
    {
        path: '/memberscard',
        component: DefaultLayout,
        children: [
            {
                path: '',
                name: 'MembersCard',
                component: MembersCard
            }
        ]
    },
    {
        path: '/mypage-link',
        component: DefaultLayout,
        children: [
            {
                path: '',
                name: 'MyPageLink',
                component: MyPageLink
            }
        ]
    },
    {
        path: '/',
        redirect: '/404',
        component: DefaultLayout,
        children: [
            {
                path: '/error/',
                name: 'Error',
                component: Error
            },
            {
                path: '/ltimeout/',
                name: 'Timeout',
                component: Timeout
            },
            {
                path: ':catchAll(.*)',
                name: 'NotFound',
                component: NotFound
            }
        ]
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
